import { render, staticRenderFns } from "./TabelaCaracteristicasProduto.vue?vue&type=template&id=96e10ff6&scoped=true"
import script from "./TabelaCaracteristicasProduto.vue?vue&type=script&lang=js"
export * from "./TabelaCaracteristicasProduto.vue?vue&type=script&lang=js"
import style0 from "./TabelaCaracteristicasProduto.vue?vue&type=style&index=0&id=96e10ff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e10ff6",
  null
  
)

export default component.exports